import { type AccessTarget, can, canTenant, seesMoney } from './access';
import type { Access } from './schemas';

export const PROJECT_DOCUMENT_TYPES = [
  { type: 'project_document', title: 'Документ проекта', hint: 'Сотрудники с доступом к документам проекта' },
  {
    type: 'project_document_money',
    title: 'Ставки и стоимость',
    hint: 'Дополнительно нужен полный доступ к деньгам',
  },
  {
    type: 'project_document_staff',
    title: 'Сведения о сотрудниках',
    hint: 'Дополнительно нужен доступ к оргструктуре всей компании',
  },
] as const;
export type ProjectDocumentType = (typeof PROJECT_DOCUMENT_TYPES)[number]['type'];
export const PROJECT_DOCUMENT_MAX_BYTES = 20 * 1024 * 1024;
export function isProjectDocumentType(value: string | undefined): value is ProjectDocumentType {
  return PROJECT_DOCUMENT_TYPES.some((x) => x.type === value);
}

/** Одинаковые ограничения списка, загрузки и прямого скачивания. Внешняя выдача — отдельный процесс. */
export function canProjectDocument(
  access: Access | null | undefined,
  staff: boolean,
  target: AccessTarget,
  type: ProjectDocumentType,
  write = false,
): boolean {
  return (
    staff &&
    can(access, 'documents.view', target) &&
    (!write || can(access, 'documents.edit', target)) &&
    (type !== 'project_document_money' || seesMoney(access)) &&
    (type !== 'project_document_staff' || canTenant(access, 'admin.org'))
  );
}
